<template>
  <div class="campaign-base">
    <block-hero />
    <!-- <block-period /> -->
    <block-howto />
    <!-- <block-benefit /> -->
    <!-- <block-attention /> -->
    <block-subsc-contents />
    <lp-footer :color-scheme="colorScheme" :menu-list="footerMenuList" :showToTopBtn="false" />
    <friend-button :class="[ showFriendBtn ? 'show' : '']"/>
  </div>
</template>

<script>
import { DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import BlockHero from './blocks/BlockHero'
import BlockPeriod from './blocks/BlockPeriod'
import BlockHowto from './blocks/BlockHowto'
import BlockSubscContents from './blocks/BlockSubscContents'
// import BlockBenefit from './blocks/BlockBenefit'
// import BlockAttention from './blocks/BlockAttention'
import FriendButton from './partials/FriendButton'
import LpFooter from '@/utvStore/components/recommend/lp/blocks/LpFooter'

export default {
  name: 'LineCampaign202110',
  components: {
    LpFooter,
    BlockHero,
    BlockPeriod,
    BlockHowto,
    BlockSubscContents,
    // BlockBenefit,
    // BlockAttention,
    FriendButton
  },
  data(){
    return {
      showFriendBtn :true
    }
  },
  computed: {
    colorScheme() {
      return {
        keyColor: '#aab2bd'
      }
    },
    footerMenuList(){
      return [ ...DEFAULT_FOOTER_MENULIST, ]
    },
  },
  mounted(){
    document.addEventListener('scroll', this.scroll)
  },
  methods:{
    scroll(){
      //ライン友達追加ボタンはフッターあたりで非表示にする
      const bottom = document.body.clientHeight - window.innerHeight
      const scroll = window.pageYOffset
      this.showFriendBtn = bottom * 0.9 > scroll
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

.campaign-base{
  background: $col_white;
  max-width: 580px;
  margin: 0 auto;
  position: relative;
  font-size: 14px;
  line-height: 21px;
  @include mq('w580'){
    font-size: 16px;
    line-height: 23px;
  }

  .friend-button{
    width: fit-content;
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 100;
    transition: opacity .3s ease;
    opacity: 0;
    pointer-events: none;
    @include mq('w580'){
      left: auto;
      right: auto;
      margin: 0 0 0 460px;
    }
    &.show{
      opacity: 1;
      pointer-events: auto;
    }
  }
}

/deep/ .basic-block {
  color: $col_black;

  .content-wrap {
    width: 100%;
    position: relative;
    z-index: 100;
  }

  h1 {
    font-size: 24px;
    line-height: 34px;
    text-align: center;
    margin: 0 0 24px;
    &::after {
      content: '';
      display: block;
      width: 46px;
      height: 4px;
      margin: 4px auto 0;
      background: #06C755;
    }
    @include mq('w580'){
      font-size: 26px;
      line-height: 36px;
    }
  }

  h2 {
    font-weight: bold;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    @include mq('w580'){
      font-size: 22px;
      line-height: 32px;
    }
  }

  .attention {
    font-weight: bold;
    font-size: 12px;
    line-height: 18px;
    color: $col_temp_key1;
    margin: 8px 0 0;
    @include mq('w580'){
      font-size: 14px;
      line-height: 20px;
    }
  }

  p {
    margin: 0;
  }
}
</style>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/lp/campaign/LineCampaign202110/index.vue